import React, { Component } from 'react'
export default class BottomLine extends Component {

  render() {
    return (
      <div>
          {String.fromCharCode(160)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomLine.js